export const PRINT_POST_URL_KEY = 'rph'
export const PRINT_GACHA_URL_KEY = 'gpr'

export const APP_INSTALL_PERMISSION_REQUEST_URL =
  'https://fanme-support.zendesk.com/hc/ja/requests/new'
